import { useTranslations } from '@vocab/react';
import { Text, TooltipRenderer, Box, Inline } from 'braid-design-system';
import { IconCertified } from 'src/components/common/Certsy/Icons/IconCertified/IconCertified';
import { certsyPurple } from 'src/constants/styles';

import translations from './.vocab';

export const CertsyIdentityVerified = ({
  idSuffix,
  certsyVerifiedFullName,
}: {
  idSuffix: string;
  certsyVerifiedFullName: string;
}) => {
  const { t } = useTranslations(translations);

  return (
    <TooltipRenderer
      id={`certsy-identity-verified-tooltip-${idSuffix}`}
      tooltip={
        <Text>
          {t(
            'This person has verified their identity as certsyVerifiedFullName.',
            {
              certsyVerifiedFullName,
            },
          )}
        </Text>
      }
    >
      {({ triggerProps }) => (
        <Box {...triggerProps}>
          <Inline space="none" alignY="center">
            <IconCertified color={certsyPurple} />
            <Box style={{ paddingLeft: '2px' }}>
              <Text size="small" tone="secondary">
                {t('Identity verified')}
              </Text>
            </Box>
          </Inline>
        </Box>
      )}
    </TooltipRenderer>
  );
};
